var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMo = function SvgMo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#496E2D",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M14.087 11.5c-.294 0-.574.059-.834.152.143-.317.238-.67.238-1.046 0-1.49-1.49-2.609-1.49-2.609s-1.491 1.118-1.491 2.609c0 .377.095.73.237 1.046a2.46 2.46 0 0 0-.834-.152c-1.49 0-2.608 1.49-2.608 1.49s1.118 1.492 2.608 1.492c.874 0 1.62-.513 2.087-.937.468.424 1.213.937 2.087.937 1.491 0 2.609-1.491 2.609-1.491s-1.118-1.49-2.609-1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "m12 4.695.309.947h.996l-.806.586.308.948L12 6.59l-.806.586.307-.948-.806-.586h.997L12 4.695ZM8.211 6.352l.593.533.69-.399-.324.729.592.533-.793-.083-.324.728-.166-.78-.792-.083.69-.399-.166-.78ZM5.438 9.126l.78.166.398-.69.083.792.78.166-.728.324.083.793-.534-.592-.728.324.399-.69-.534-.593ZM15.79 6.352l-.593.533-.69-.399.324.729-.593.533.793-.083.324.728.166-.78.793-.083-.69-.399.165-.78ZM18.563 9.126l-.78.166-.399-.69-.083.792-.78.166.729.324-.084.793.534-.592.728.324-.399-.69.534-.593Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 18.655a5.193 5.193 0 0 0 3.15-1.06H8.85a5.193 5.193 0 0 0 3.15 1.06ZM7.217 15.524c.165.38.375.734.622 1.06h8.321c.247-.326.457-.68.622-1.06H7.217Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgMo;